import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'

interface AccessibilityContextData {
  contrastIsSelected: boolean
  toogleContrast: () => void
  addLengthText: () => void
  removeLengthText: () => void
  resetLengthText: () => void
  lengthText: number
}

export const AccessibilityContext = createContext<AccessibilityContextData>(
  {} as AccessibilityContextData
)

interface ContextProps {
  children: React.ReactNode
}

const APP_KEY_STORAGE = '@INTEGRA_SOCIAL_APP'

const html = document.getElementsByTagName('html')[0]

function AccessibilityProvider({ children }: ContextProps) {
  const [contrastIsSelected, setContrastIsSelected] = useState<boolean>(
    (): boolean => {
      const storagedContrastValue = localStorage.getItem(
        `${APP_KEY_STORAGE}_CONTRAST`
      )

      if (storagedContrastValue === 'true') {
        return true
      }

      return false
    }
  )
  const [lengthText, setLengthText] = useState<number>(() => {
    const storedLengthTextValue = localStorage.getItem(
      `${APP_KEY_STORAGE}_LENGTHTEXT`
    )

    if (storedLengthTextValue != null) {
      return JSON.parse(storedLengthTextValue)
    }
    return 60
  })

  // actions contrast
  const toogleContrast = useCallback(() => {
    setContrastIsSelected(!contrastIsSelected)
  }, [contrastIsSelected])

  useEffect(() => {
    localStorage.setItem(
      `${APP_KEY_STORAGE}_CONTRAST`,
      contrastIsSelected ? 'true' : 'false'
    )
  }, [contrastIsSelected])

  useEffect(() => {
    window.localStorage.setItem(
      `${APP_KEY_STORAGE}_LENGTHTEXT`,
      JSON.stringify(lengthText)
    )

    html.style.fontSize = `${lengthText}%`
  }, [lengthText])

  const addLengthText = () => {
    if (lengthText < 80) {
      setLengthText((prev: number) => prev + 4)
    }
  }
  const removeLengthText = () => {
    if (lengthText > 60) {
      setLengthText((prev: number) => prev - 4)
    }
  }

  const resetLengthText = () => {
    setLengthText(60)
  }

  const valuesProvider = useMemo(() => {
    return {
      contrastIsSelected,
      toogleContrast,
      addLengthText,
      removeLengthText,
      resetLengthText,
      lengthText,
    }
  }, [
    contrastIsSelected,
    toogleContrast,
    addLengthText,
    removeLengthText,
    resetLengthText,
    lengthText,
  ])

  return (
    <AccessibilityContext.Provider value={valuesProvider}>
      {children}
    </AccessibilityContext.Provider>
  )
}

const useAccessibility = () => useContext(AccessibilityContext)

export { AccessibilityProvider, useAccessibility }
